import { createSlice } from '@reduxjs/toolkit';
// import Strings from '@/constants/String';
// import BaseApiState from '@/api/BaseApiState';
import { DataToUpdateForSlotsByGroupIdType} from "@/types/interfaceType";


interface GlobalState {
  themeMode: string,
  isLoading: boolean,
  dataToUpdateForSlotsByGroupId:DataToUpdateForSlotsByGroupIdType,
  selectedSportId:string,
  selectedCourtId:string
  showPaymentProcessing:boolean,
  showPaymentSuccess:boolean,

}



const initialState:GlobalState = {
  showPaymentProcessing:false,
  showPaymentSuccess:false,
  themeMode: localStorage.getItem('theme') || 'light',
  isLoading: false,
  dataToUpdateForSlotsByGroupId:null,
  selectedSportId:'',
  selectedCourtId:''
}

const globalSlice = createSlice({
  name: 'globalState',
  initialState,
  reducers: {
    setShowPaymentProcessing:(state, action) => {
      state.showPaymentProcessing = action.payload
    },
    setShowPaymentSuccess:(state, action) => {
      state.showPaymentSuccess = action.payload
    },
    setSelectedSportId:(state, action) => {
      state.selectedSportId = action.payload;

    },
    setSelectedCourtId:(state, action) => {
      state.selectedCourtId = action.payload;
    },

    resetSportAndcourtId:(state) => {
      state.selectedCourtId = '';
      state.selectedSportId = '';
    },

    setisLoading: (state, action) => {
      state.isLoading = action.payload;
    },

    ResetDataToUpdateForSlotsByGroupId: (state) => {
      state.dataToUpdateForSlotsByGroupId = null
    },
    setDataToUpdateForSlotsByGroupId:(state,action)=>{
      let {groupId,data} =action.payload
      state.dataToUpdateForSlotsByGroupId={
        ...state.dataToUpdateForSlotsByGroupId,
        [groupId]:{
          ...state.dataToUpdateForSlotsByGroupId?.[groupId],
          ...data,
          discount: {
            ...state.dataToUpdateForSlotsByGroupId?.[groupId]?.discount,
            ...data.discount,
          },
        }
      
      }
    }

  },
});

export const {
  setisLoading,
  setDataToUpdateForSlotsByGroupId,
  ResetDataToUpdateForSlotsByGroupId,
  resetSportAndcourtId,
  setSelectedCourtId,
  setSelectedSportId,
  setShowPaymentProcessing,
  setShowPaymentSuccess

} = globalSlice.actions;
export default globalSlice.reducer;

